// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
var EVENT_PREFIX = 'forge.bridge.';
export function on(event, callback, extension) {
  var wrappedCallback = function wrappedCallback(e) {
    var _e$detail, _e$detail2, _e$detail3;
    if (!extension || !((_e$detail = e.detail) !== null && _e$detail !== void 0 && _e$detail.extension) || extension.id === ((_e$detail2 = e.detail) === null || _e$detail2 === void 0 || (_e$detail2 = _e$detail2.extension) === null || _e$detail2 === void 0 ? void 0 : _e$detail2.id) && extension.installationId === ((_e$detail3 = e.detail) === null || _e$detail3 === void 0 || (_e$detail3 = _e$detail3.extension) === null || _e$detail3 === void 0 ? void 0 : _e$detail3.installationId)) {
      var _e$detail4, _e$detail5;
      callback((_e$detail4 = e.detail) === null || _e$detail4 === void 0 ? void 0 : _e$detail4.payload, (_e$detail5 = e.detail) === null || _e$detail5 === void 0 ? void 0 : _e$detail5.extension);
    }
  };
  window.document.addEventListener("".concat(EVENT_PREFIX).concat(event), wrappedCallback);
  return {
    unsubscribe: function unsubscribe() {
      return window.document.removeEventListener("".concat(EVENT_PREFIX).concat(event), wrappedCallback);
    }
  };
}
export function emit(event, payload, extension) {
  var newEvent = new CustomEvent("".concat(EVENT_PREFIX).concat(event), {
    detail: {
      extension: extension,
      payload: payload
    }
  });
  window.document.dispatchEvent(newEvent);
}